import FiltersBoxA from './FiltersBoxA';
import FiltersBoxB from './FiltersBoxB';

export { FiltersBoxA, FiltersBoxB };
